/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Styles
import '@/assets/scss/main.scss'

// Components
import { createApp, h, Fragment, App } from 'vue'
import MainApp from './App.vue'

// Composables
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import { createPinia, storeToRefs } from 'pinia'
import { i18n } from '@/i18n'
import { VueAxePopup } from 'vue-axe'
import Auth from '@/modules/auth/components/Auth.vue'
import VueAxe from 'vue-axe'
import { PDFPlugin } from 'vue3-pdfmake'
import { eventBus } from './plugins/eventBus'
import { useAuthStore } from './modules/auth/store'
import { draggable } from '@/directives/draggable'

let current: 'APP' | 'AUTH' | null = null
const pinia = createPinia()
let app: App<Element> | null = null

const auth = createApp(Auth)
auth.use(pinia)
auth.use(vuetify)
auth.use(i18n)
auth.use(PDFPlugin)
auth.directive('draggable', draggable)

function mountAuth() {
  if (current !== 'AUTH' && app) {
    app.unmount()
  }
  if (current !== 'AUTH') {
    current = 'AUTH'
    auth.mount('#app')
    app = auth
  }
}

mountAuth()

eventBus.$on('startApp', (route: string | undefined) => {
  history.replaceState(null, '', '/vigo-ot/')

  const { idToken } = storeToRefs(useAuthStore())
  if (!idToken.value?.permissions) {
    history.replaceState(null, '', '/vigo-ot/')
    mountAuth()
    return
  }

  if (current === 'AUTH' && app) {
    app.unmount()
  }

  if (process.env.NODE_ENV == 'development') {
    app = createApp({
      render: () => h(Fragment, [h(MainApp), h(VueAxePopup)])
    })
    app.use(VueAxe)
  } else {
    app = createApp(MainApp)
  }

  if (route) {
    router.replace(route)
  } else {
    router.replace('/')
  }

  app.use(pinia)
  app.use(vuetify)
  app.use(i18n)
  app.use(router)
  app.use(PDFPlugin)
  app.directive('draggable', draggable)

  current = 'APP'
  app.mount('#app')
})

eventBus.$on('authError', () => {
  mountAuth()
})
